/**
 * Wrapper class to record a decoding error.
 */

class DecodeError {
    constructor(message) {
        this.message = message
    }
}

export default DecodeError